import { render, staticRenderFns } from "./order-summary-mini-copy.vue?vue&type=template&id=1f6fa769"
import script from "./order-summary-mini-copy.vue?vue&type=script&lang=ts"
export * from "./order-summary-mini-copy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f6fa769')) {
      api.createRecord('1f6fa769', component.options)
    } else {
      api.reload('1f6fa769', component.options)
    }
    module.hot.accept("./order-summary-mini-copy.vue?vue&type=template&id=1f6fa769", function () {
      api.rerender('1f6fa769', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/order-summary-mini-copy.vue"
export default component.exports